import { Component, Input, OnInit } from "@angular/core";
import * as $ from "jquery";
import Swal from "sweetalert2";
import { ApiService } from "src/app/service/apiServices";
import { AuthService } from "src/app/service/auth/auth.service";
import { SafeUrl } from "@angular/platform-browser";
import { Global } from "src/app/global";

@Component({
  selector: "app-certificate-list",
  templateUrl: "./certificate-list.component.html",
  styleUrls: ["./certificate-list.component.css"],
})
export class CertificateListComponent implements OnInit {
  @Input() ListaAbaAtestado: any = [];
  @Input() prontuario: any = [];

  atestado: any = {};
  dadosImpresso: any;
  dataHoje: any = "";
  fileUrl: SafeUrl;
  visualizar_prontuario: any = false;
  constructor(
    public global: Global,
    public service: ApiService,
    private authService: AuthService
  ) {
    this.authService.visualizarProntuario.subscribe((res) => {
      if (res) {
        this.visualizar_prontuario = res;
      }
    });
  }

  ngOnInit() {}

  visualizarAtestado(atestado) {
    this.atestado = atestado;
    // if (atestado.tipo_atestado == 'PADRAO')
    //   this.atestado.texto = `Atesto que o paciente ${this.atestado.cidadao_nome} necessita de ${this.atestado.dias.toString()} dia(s) de afastamento do trabalho por motivo de doença, a partir do dia ${this.global.formateDate(this.atestado.criado_em)}.`;
    $("#modalVisualizarAtestado").toggleClass("show");
    $("#modalVisualizarAtestado").css("display", "block");
  }

  fecharModal = () => {
    $("#modalVisualizarAtestado").toggleClass("show");
    $("#modalVisualizarAtestado").css("display", "none");
  };

  imprimirDado(item: any) {
    var tipo_declaracao = "";

    if (item.tipo_atestado == "PADRAO") {
      tipo_declaracao = "ATESTADO_PADRAO.frx";
    } else if (item.tipo_atestado == "LIVRE") {
      tipo_declaracao = "ATESTADO_LIVRE.frx";
    }
    Swal.fire("Favor aguarde");
    Swal.showLoading();
    this.service
      .PostImpresso(`Documento/impresso-pdf/`+ tipo_declaracao, [
        {
          nome: "id",
          valor: item.id.toString(),
        },
      ])
      .then((res) => {
        if (res) {
          var link: any = res;
          Swal.close();
          window.open(link, "_blank");
        }
      });
  }
  enviarWhatsApp(item: any) {
    Swal.fire("Favor aguarde");
    Swal.showLoading();
    var tipoAtestadoImpresso: Number = 6;
    if (item.tipo_atestado == "LIVRE") tipoAtestadoImpresso = 5;

    this.service
      .Get(
        `Documento/impresso/Whatsapp/${item.id}?atendimento_id=${this.prontuario.atendimento_id}&tipo_documento=${tipoAtestadoImpresso}`
      )
      .then((res) => {
        Swal.fire({
          icon: "success",
          title: "Sucesso",
          text: "Atestado enviado com sucesso!",
        }).then(() => {
          Swal.close();
        });
      })
      .catch((err) => {
        Swal.fire({
          icon: "error",
          title: "Erro",
          text: "Erro ao enviar o atestado!",
        }).then(() => {
          Swal.close();
        });
      });    
  }
}
